if (!customElements.get('collapsible-content-faq')) {
    customElements.define('collapsible-content-faq',
        class collapFAQContentElement extends HTMLElement {
            constructor() {
                super();

                var details = document.querySelectorAll(".faq-details");
                var jsonArray = [];
                details.forEach((d) => {
                    d.addEventListener("click", function () {
                        let elem = d;
                        details.forEach(function (detail) {
                            if (elem !== detail) {
                                detail.querySelector('details').removeAttribute('open');
                                detail.querySelector('summary').classList.remove('open');
                            } else {
                                detail.querySelector('summary').classList.add('open');
                            }
                        });
                    });

                    var sectionId = d.querySelector('h3').getAttribute('data-quest');
                    var quest = d.querySelector('h3').innerHTML.replaceAll(/(<([^>]+)>)/gi, "").replaceAll("\n", "").replaceAll("&nbsp;", "").trim()
                    var ans = document.querySelector('[data-ans="' + sectionId + '"]').innerHTML.replaceAll(/(<([^>]+)>)/gi, "").replaceAll("\n", "").replaceAll("&nbsp;", "").trim();
                    var jsonString = {
                        "@type": "Question",
                        "name": quest,
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": ans
                        }
                    };
                    jsonArray.push(jsonString);

                });


                function ModifyJsonFAQ(jsonElement) {
                    jsonElement["mainEntity"] = jsonArray;
                    return jsonElement;
                }
                var graph = document.querySelector("#yoast-schema-graph");
                if (graph === null || graph === undefined) return;
                var json = JSON.parse(graph.innerHTML)["@graph"];
                if (json === undefined) return;

                for (var i = 0; i < json.length; i++) {
                    var j = json[i];
                    if (Array.isArray(j["@type"])) {
                        for (var index = 0; index < j["@type"].length; index++) {
                            var st = j["@type"][index];
                            if (st === "FAQPage") {
                                json[i]["@type"] = "WebPage";
                                break;
                            }
                        }
                    } else if (j["@type"] === "FAQPage") {
                        json[i] = ModifyJsonFAQ(json[i]);
                    }
                }

                var js = {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": jsonArray
                };
                json.push(js);
                document.querySelector("#yoast-schema-graph").innerHTML = JSON.stringify(json);


            }
        }
    )
}  ;
